import { Headline } from '@vkontakte/vkui';
import { requestPayment } from 'Cloud/Application/Payment';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ACTION_PROMO } from 'reactApp/appHelpers/configHelpers';
import { getFeatureMarketingPromoButton } from 'reactApp/modules/features/features.selectors';
import { UserStorageActions, UserStorageSelectors } from 'reactApp/modules/user/userStorage';
import { RootState } from 'reactApp/store';
import { ESplashScreenAction, useSplashScreenAnalytics } from 'reactApp/ui/Mobile/SplashScreen/SplashScreen.analytics';

import styles from './MarketingPromoButton.css';

const PROMO_ID = 'attaches-marketing-promo';

export const MarketingPromoButton: FC = () => {
    const dispatch = useDispatch();

    const featureData = useSelector(getFeatureMarketingPromoButton);
    const showCount = useSelector((state: RootState) => UserStorageSelectors.get(state, PROMO_ID));

    const maxShowCount = featureData?.showCount || 5;

    const [visible, setVisible] = useState(() => Boolean(ACTION_PROMO) && Boolean(featureData) && (!showCount || showCount < maxShowCount));

    const sendSplashScreenAnalytics = useSplashScreenAnalytics({ name: 'attaches-marketing-btn', button_name: featureData?.text || '' });

    useEffect(() => {
        if (visible) {
            sendSplashScreenAnalytics(ESplashScreenAction.show);
            dispatch(UserStorageActions.set(PROMO_ID, showCount ? showCount + 1 : 1));
        }
    }, []);

    const onClick = useCallback(() => {
        sendSplashScreenAnalytics(ESplashScreenAction.click);
        dispatch(UserStorageActions.set(PROMO_ID, maxShowCount));
        if (featureData?.productId) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            requestPayment({ tariff: featureData.productId, forceFastCheckout: true, onClose: () => setVisible(false) });
        }
    }, [dispatch, featureData?.productId, maxShowCount]);

    return visible ? (
        <div className={styles.button} onClick={onClick}>
            <Headline level="2" weight="1">
                {featureData?.text}
            </Headline>
        </div>
    ) : null;
};
